import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import getFingerprint from "../validations/fingerprint";

type GetAPI = {
    params: any;
    url: string;
    type: "axios" | "admin" | "buyadmin" | "custom" | "new_admin";
    urlPath?: string;
};
type PostAPI = {
    body: any;
    url: string;
    type: "axios" | "admin" | "buyadmin" | "custom" | "new_admin";
    urlPath?: string;
};

interface AxiosInstanceWithAuth extends AxiosInstance {
    interceptors: {
        request: AxiosInstance["interceptors"]["request"];
        response: AxiosInstance["interceptors"]["response"];
    };
}

export const commonHeaders: AxiosRequestConfig["headers"] = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-internal-app": "Sharepal",
};

const new_axios: AxiosInstanceWithAuth = axios.create({
    headers: commonHeaders,
});

export const getAdminApi = (url: string, type?: "xano" | "other") => {
    const BASEURL =
        type == "other" || url.startsWith("https://")
            ? url
            : "https://api.sharepal.in/api:" + url;

    const api: AxiosInstanceWithAuth = axios.create({
        baseURL: BASEURL,
        headers: commonHeaders,
    });

    api.interceptors.request.use(
        async (config: any) => {
            const token =
                typeof window !== "undefined" && localStorage.getItem("token");
            if (token) {
                if (!config.headers) {
                    config.headers = {};
                }
                try {
                    const fingerprint = await getFingerprint();
                    config.headers["User-Id"] = fingerprint;
                } catch (error) {
                    console.warn("Failed to get fingerprint:", error);
                }
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    api.interceptors.response.use(
        (response: AxiosResponse) => {
            return response;
        },
        (error) => {
            if (error.response && error.response.status === 401) {
                console.log("Unauthorized error");
            } else {
                console.error("An error occurred:", error.message);
            }
            return Promise.reject(error);
        }
    );

    return api;
};

export const API = {
    axios: new_axios,
    new_admin: getAdminApi("3sDks8XW"),
};

export async function getApi<T>({ params, url, type = "axios" }: GetAPI) {
    const { data } = await API[type].get(url, { params });
    return data as T;
}

export async function postApi<T>({ body, url, type = "axios" }: PostAPI) {
    const { data } = await API[type].post(url, body);
    return data as T;
}

export async function deleteApi<T>({ body, url, type = "axios" }: PostAPI) {
    const { data } = await API[type].delete(url, {
        data: body,
    });
    return data as T;
}

export async function customPostApi<T>({ body, url, urlPath }: PostAPI) {
    const { data } = await getAdminApi(urlPath ?? "3sDks8XW").post(url, body);
    return data as T;
}

export async function customGetApi<T>({ params, url, urlPath }: GetAPI) {
    const { data } = await getAdminApi(urlPath ?? "3sDks8XW").get(url, {
        params,
    });
    return data as T;
}
